import { convertItemsToTreesMap, mutateTreeTyped } from "../common/tree"
import {
    ApplicationTemplateCategory,
    ApplicationTemplateMutation,
    ApplicationTemplateTreeData,
    ApplicationTemplateTreeItem,
    ApplicationTemplateVersionCategory
} from "../../models/workshop/template"
import { ItemId, TemplateVersionStatus } from "../../models/workshop/common"

export const convertApplicationTemplatesToTreeItem = (
    version: ApplicationTemplateVersionCategory,
    categoryId: string
): ApplicationTemplateTreeItem => ({
    id: version.Id,
    children: [],
    hasChildren: false,
    isExpanded: false,
    isChildrenLoading: false,
    data: {
        id: version.Id,
        title: version.Title,
        parentId: categoryId,
        ...version
    }
})

export const convertApplicationTemplatesToTreeItemsMap = (
    versions: ApplicationTemplateVersionCategory[],
    categoryId: string
): Record<ItemId, ApplicationTemplateTreeItem> => {
    return [...versions]
        .sort((a, b) => a.Audit.UpdateTimestamp - b.Audit.UpdateTimestamp)
        .reduce<Record<ItemId, ApplicationTemplateTreeItem>>(
            (acc, version) => ({
                ...acc,
                [version.Id]: convertApplicationTemplatesToTreeItem(version, categoryId)
            }),
            {}
        )
}

export const convertApplicationTemplateToTree = (
    template: ApplicationTemplateCategory
): ApplicationTemplateTreeData => {
    const items = convertApplicationTemplatesToTreeItemsMap(template.Versions, template.Id)

    const applicationTemplateItem: ApplicationTemplateTreeItem = {
        id: template.Id,
        children: Object.keys(items),
        hasChildren: true,
        isExpanded: true,
        isChildrenLoading: false,
        data: {
            id: template.Id,
            title: template.Title,
            parentId: "",
            Status: TemplateVersionStatus.DRAFT,
            ...template
        }
    }

    return {
        rootId: template.Id,
        items: {
            [applicationTemplateItem.id]: applicationTemplateItem,
            ...items
        }
    }
}

export const convertApplicationTemplatesToTree = (catalog: ApplicationTemplateCategory[]) => {
    return convertItemsToTreesMap(catalog, convertApplicationTemplateToTree)
}

export const applicationTemplateToTreeMutation = (
    mutation: ApplicationTemplateMutation,
    item: ApplicationTemplateTreeItem
): ApplicationTemplateTreeItem => {
    const { Status, Title, Audit } = mutation

    return {
        ...item,
        data: {
            ...item.data,
            ...(Status && { Status: Status }),
            ...(Title && { Title: Title, title: Title }),
            ...(Audit && { Audit: Audit })
        }
    }
}

export const addApplicationTemplateVersions = (
    applicationId: ItemId,
    tree: ApplicationTemplateTreeData,
    versions: ApplicationTemplateVersionCategory[]
): ApplicationTemplateTreeData => {
    const items = convertApplicationTemplatesToTreeItemsMap(versions, applicationId)
    const newChildren = Object.keys(items)
    const oldChildrenWithoutRepeats = tree.items[applicationId].children
    const children = [...oldChildrenWithoutRepeats, ...newChildren]

    const newTree = {
        rootId: tree.rootId,
        items: {
            ...tree.items,
            ...items
        }
    }

    return mutateTreeTyped(newTree, applicationId, { children, isChildrenLoading: false })
}
